import { useState } from "react";

import { Button } from "@luce/ui";

import { ChangePhoneNumberModal } from "../../change-phone-number/change-phone-number-modal";
import { useAccountInfoContext } from "../account-info-context";

export function ChangePhoneNumberButton() {
  const { onPhoneNumberChanged } = useAccountInfoContext();
  const [open, setOpen] = useState(false);

  return (
    <>
      <Button variant="tertiary" size="sm" label="Change" onClick={() => setOpen(true)} />
      <ChangePhoneNumberModal
        open={open}
        onOpenChange={setOpen}
        onPhoneNumberChanged={onPhoneNumberChanged}
      />
    </>
  );
}
